import styled from "styled-components";
import { deviceSizeQuery } from "@motain/web-shared-hub/constants";

export const ContentWrapper = styled.div`
  padding: 0 1.625rem;
  @media all and ${deviceSizeQuery.tabletPortrait} {
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-width: 68.125rem;
    margin: 0 auto;
  }
`;
